import { render, staticRenderFns } from "./cedis.vue?vue&type=template&id=54b544f6&"
import script from "./cedis.vue?vue&type=script&lang=js&"
export * from "./cedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports